import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { NewSimpleGasConnectionPage, NewSimpleGasConnectionPageProps } from "./NewSimpleGasConnectionPage";

export const EMPTY_PAGE_CONTENT: NewSimpleGasConnectionPageProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/gas/new-connection/simple";

export const NewSimpleGasConnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<NewSimpleGasConnectionPageProps>("simple_gas_connection", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <NewSimpleGasConnectionPage {...routeProps} {...content} />;
};
